import configureVendorOptions from "@/app/ec/product/[basePath]/vendor-options/configureVendorOptions";
import getLowestPriceVendorOptions from "@/app/ec/product/[basePath]/vendor-options/getLowestPriceVendorOptions";
const computeLowestPriceBadge = (
  mpId: number,
  quantity: number,
  vendorOptions: VendorOptionFromServer[],
  manufacturer?: string,
): VendorOptionState[] => {
  let vendorOptionStateList = configureVendorOptions(mpId, quantity, vendorOptions);
  if (manufacturer) {
    vendorOptionStateList = vendorOptionStateList.filter(
      (vendorOptionState) => vendorOptionState.badgeName?.toLowerCase() === manufacturer.toLowerCase(),
    );
  }
  const lowestPriceVendorOption = getLowestPriceVendorOptions(vendorOptionStateList);
  vendorOptionStateList = vendorOptionStateList.map((vo) => {
    if (vo.vendorProductId === lowestPriceVendorOption.vendorProductId) {
      vo.isLowestPrice = true;
    }
    return vo;
  });
  return vendorOptionStateList;
};
export default computeLowestPriceBadge;
